/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} User_Detail_VeknInputs */



/**
* | output |
* | --- |
* | "VEKN #{id}" |
*
* @param {User_Detail_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_vekn = /** @type {((inputs: User_Detail_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`VEKN #${i?.id}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`VEKN #${i?.id}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`VEKN #${i?.id}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`VEKN #${i?.id}`)
	return /** @type {LocalizedString} */ (`VEKN #${i?.id}`)
});